import React from "react";

import { withStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';

import FormComponent from "../../classes/FormComponent";
import Form from "../../components/Form";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from "@material-ui/core/FormGroup";
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';

const styles = {
  formLabel: {
    fontSize: 12,
  },
};


class DeviceGroupForm extends FormComponent {
  constructor() {
    super();

    this.state = {};
  }

  render() {
    if (this.state.object === undefined) {
      return null;
    }

    return(
      <Form
        submitLabel={this.props.submitLabel}
        onSubmit={this.onSubmit}
        disabled={this.props.disabled}
      >
        <div>
          <TextField
            id="name"
            label="Device type name"
            helperText="The name may only contain letters, numbers and dashes."
            margin="normal"
            value={this.state.object.name || ""}
            onChange={this.onChange}
            inputProps={{
              pattern: "[\\w-]+",
            }}
            fullWidth
            required
          />
          <TextField
            id="abbreviation"
            label="Abbreviation"
            helperText="The abbreviation may only contain letters, numbers and dashes."
            margin="normal"
            value={this.state.object.abbreviation || ""}
            onChange={this.onChange}
            inputProps={{
              pattern: "[\\w-]+",
            }}
            fullWidth
            required
          />
          <TextField
            id="description"
            label="Device type description"
            margin="normal"
            value={this.state.object.description || ""}
            onChange={this.onChange}
            fullWidth
            required
          />
          <FormGroup>
            <FormControlLabel
              label="Use output schedule"
              control={
                <Checkbox
                  id="useOutputSchedule"
                  checked={!!this.state.object.useOutputSchedule}
                  onChange={this.onChange}
                  disabled={this.props.disabled}
                  value="true"
                  color="primary"
                />
              }
            />
          </FormGroup>
          <FormHelperText>Use output schedule</FormHelperText>
          </div>
      </Form>
    );
  }
}

export default withStyles(styles)(DeviceGroupForm);
